import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { selectOpenedModalType } from '../../../redux/selectors/modal';
import { ModalSliceType } from '../../../redux/slices/modal';
import {
  DashboardDeleteModal,
  DashboardDuplicateModal,
  DashboardFolderDeleteModal,
  DashboardMoveModal,
  DashboardPublishModal,
  DashboardUnpublishModal,
} from '../components';

const DashboardModalController = () => {
  const isDeleteModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardDelete, ''),
  );
  const isFolderDeleteModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardFolderDelete, ''),
  );
  const isDuplicateModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardDuplicate, ''),
  );
  const isDashboardMoveModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardMove, ''),
  );
  const isPublishModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardPublish, ''),
  );
  const isUnpublishModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DashboardUnpublish, ''),
  );

  if (isDeleteModalOpen) {
    return <DashboardDeleteModal />;
  }

  if (isFolderDeleteModalOpen) {
    return <DashboardFolderDeleteModal />;
  }

  if (isDuplicateModalOpen) {
    return <DashboardDuplicateModal />;
  }

  if (isPublishModalOpen) {
    return <DashboardPublishModal />;
  }

  if (isDashboardMoveModalOpen) {
    return <DashboardMoveModal />;
  }

  if (isUnpublishModalOpen) {
    return <DashboardUnpublishModal />;
  }

  return null;
};

export default DashboardModalController;
